export default {"src":"/_next/static/media/ElevateLogoAndWordsnew.60ea7cf2.svg","height":24,"width":126};